import React from 'react';
import DataTable from '../DataTable';

const SampleTab = ({ samples, isFullScreen = false }) => {
  if (!samples || samples.length === 0) {
    return (
      <div className="h-full flex items-center justify-center text-gray-400 text-xs uppercase tracking-widest font-bold">
        No sample data available
      </div>
    );
  }

  const columns = Object.keys(samples[0]).map(key => ({
    key,
    label: key
  }));

  return (
    <div className="h-full -m-4">
      <DataTable
        columns={columns}
        rows={samples}
        isFullScreen={isFullScreen}
      />
    </div>
  );
};

export default SampleTab;
